import { apiClient, type ShipmentOrdersSummaryExEntity } from '@/libs/api'
import { type ShipmentOrdersRequestQuery } from '@/libs/api/types'

export type FetchShipmentOrdersSummaryQuery = {
  tenantKey: string
  /** 一覧と同じ検索条件。page / take / sort / order は集計に関係ないので渡さない */
  query: ShipmentOrdersRequestQuery
}

/**
 * 検索条件に一致する配送依頼全体の集計（件数・荷姿数・数量・重量）を取る（#5285 2.1）。
 * 一覧 API と同じ検索 DTO を受けるので、同じ query を渡せば一覧と同じ母集団になる
 */
export const fetchShipmentOrdersSummary = async (
  { tenantKey, query }: FetchShipmentOrdersSummaryQuery,
  signal?: AbortSignal
): Promise<ShipmentOrdersSummaryExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.summary.$get({
      query,
      config: {
        signal
      }
    })
  return data
}
